require('bootstrap-select');
require('slick-carousel');
require('malihu-custom-scrollbar-plugin');
require('jquery-form-styler');

import WOW from 'wow.js';

$(window).on('load', function () {
    $(".loader").delay(400).fadeOut("slow");
});

$(function () {
    (function mobileBtn() {
        let mobileBtnOpen = $('.open-nav-btn');
        let mobileBtnClose = $('.close-nav-btn');
        let mobileMenu = $('.nav-holder');

        mobileBtnOpen.on('click', function(){
            mobileMenu.addClass('show');
            $('.overlay').addClass('show');
            $('body').addClass('no-scroll');
            $('html').addClass('no-scroll');
        });
        mobileBtnClose.on('click', function(){
            mobileMenu.removeClass('show');
            $('.overlay').removeClass('show');
            $('body').removeClass('no-scroll');
            $('html').removeClass('no-scroll');
        });
    }());

    $('.scroll-down').on('click', function (event) {
        event.preventDefault();
        let id = $(this).attr('href');
        let top = $(id).offset().top;

        $('body,html').animate({
            scrollTop: top
        }, 1000);
    });

    $('.member-card').on('click', function(){
        $('.member-card.current').removeClass('current');
        $(this).addClass('current');
    });

    if ($(window).outerWidth() > 767) {
        $(".text-scroll").mCustomScrollbar({
            theme:"minimal"
        });
    }

    $(".testim-text").mCustomScrollbar({
        theme:"minimal"
    });
    // $(".modal-inner-text").mCustomScrollbar({
    //     theme:"light"
    // });

    // Slick slider
    $('.testimonials-slider').slick({
        dots: false,
        infinite: false,
        cssEase: 'linear',
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        responsive: [
            {
                breakpoint:  1199.98,
                settings: {
                slidesToShow: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                slidesToShow: 1,
                arrows: false,
                dots:true,
                dotsClass: "my-dots",
                }
            }
            ]
    });

     //Show and hide password value
     $('.view-pass').click(function () {
        if ($(this).hasClass('active')) {
            $('#password').attr('type', 'text');
            $(this).removeClass('active');
        } else {
            $('#password').attr('type', 'password');
            $(this).addClass('active');
        }
    });
});

new WOW().init();





